import React from "react";
import Checkbox from "@streeteasy/design-system/deprecated/Checkbox";
import { array, bool, func, int, number, obj, shape, string } from "prop-types";

import * as S from "./styled";

const NeighborhoodWithCheckbox = ({
  isChecked,
  isHovered,
  isTitle,
  neighborhood,
  onCheck,
  onHover,
  shouldIndent,
  showCheckBox
}) => {
  const { id, name } = neighborhood;

  const handleOnCheck = () => {
    onCheck(neighborhood);
  };

  return (
    <S.NeighborhoodWithCheckboxContainer
      onBlur={() => onHover(null)}
      onMouseEnter={() => onHover(id)}
      onMouseOut={() => onHover(null)}
      shouldIndent={shouldIndent}
    >
      {showCheckBox && (
        <Checkbox isChecked={isChecked} onChange={handleOnCheck} />
      )}
      <S.NeighborhoodTitle
        isHovered={isHovered}
        isTitle={isTitle}
        nameLength={name.length}
        showCheckBox={showCheckBox}
        type="sm"
      >
        {name}
      </S.NeighborhoodTitle>
    </S.NeighborhoodWithCheckboxContainer>
  );
};

NeighborhoodWithCheckbox.propTypes = {
  neighborhood: shape({
    decodedCoordinates: array,
    id: number,
    level: number,
    map_coordinates: obj,
    name: string,
    parent_id: int
  }).isRequired,
  showCheckBox: bool,
  isTitle: bool,
  shouldIndent: bool,
  onCheck: func,
  onHover: func,
  isChecked: bool,
  isHovered: bool
};

NeighborhoodWithCheckbox.defaultProps = {
  showCheckBox: true,
  isTitle: false,
  shouldIndent: false,
  onCheck: () => {},
  onHover: () => {},
  isChecked: false,
  isHovered: false
};

export default NeighborhoodWithCheckbox;
